var u = /* @__PURE__ */ ((r) => (r.default = "default", r.light = "light", r))(u || {}), d = /* @__PURE__ */ ((r) => (r.up = "up", r.down = "down", r.left = "left", r.right = "right", r))(d || {});
export {
  d as TooltipPlacement,
  u as TooltipVariant
};
